import _extends from "@babel/runtime/helpers/extends";
import React, { useState, useRef } from 'react';
import { Checkbox, Text, Box, Badge } from '@wix/design-system';
import { WidgetLayout } from '../shared/WidgetLayout/WidgetLayout';
import { CardLayout } from '../shared/CardLayout/CardLayout';
import s from './MultiSelectWidget.module.scss';
import { generateId } from '../shared/utils';
import { Picture } from '../shared/Picture/Picture';
import { useDisabledWidget } from '../../../shared/disabled-widget/useDisabledWidget';
import { WithDisabledControl } from '../../../shared/disabled-widget/WithDisabledControl';
export const MultiSelectWidget = _ref => {
  var _data$secondaryButton, _data$primaryButton;
  let {
    data,
    context,
    config
  } = _ref;
  const {
    areControlsDisabled,
    enableControls
  } = useDisabledWidget(config);
  const widgetId = useRef(generateId());
  const [selectedValues, setSelectedValues] = useState([]);
  const selectedTitles = (data.options ?? []).filter(_ref2 => {
    let {
      value
    } = _ref2;
    return selectedValues.includes(value);
  }).map(_ref3 => {
    let {
      title
    } = _ref3;
    return title ?? '';
  });
  const handleButtonClick = function (action, label) {
    if (label === void 0) {
      label = '';
    }
    const handler = effects => {
      const onWidgetActionData = {
        action,
        value: {
          label,
          effects
        }
      };
      context.onWidgetAction(MULTI_SELECT_WIDGET, onWidgetActionData, data.text);
    };
    return handler;
  };
  const handleCheckboxClick = (value, label) => {
    let shouldAdd;
    setSelectedValues(prev => {
      shouldAdd = !prev.includes(value);
      return shouldAdd ? [...prev, value] : prev.filter(v => v !== value);
    });
    const onWidgetActionData = {
      action: shouldAdd ? 'checkbox_select' : 'checkbox_unselect',
      value: {
        value,
        label
      }
    };
    context.onWidgetAction(MULTI_SELECT_WIDGET, onWidgetActionData, data.text);
  };
  const cards = (data.options ?? []).map(_ref4 => {
    let {
      picture,
      title,
      text,
      value,
      badge
    } = _ref4;
    return /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      gap: "SP2",
      align: "left",
      key: value
    }, badge != null && badge.text ? /*#__PURE__*/React.createElement(Badge, {
      skin: (badge == null ? void 0 : badge.skin) || 'neutralStandard',
      type: badge == null ? void 0 : badge.type,
      size: "tiny"
    }, badge.text) : null, /*#__PURE__*/React.createElement(CardLayout, {
      key: value,
      borderless: data.borderlessOptions
    }, (picture == null ? void 0 : picture.url) && /*#__PURE__*/React.createElement(Picture, _extends({}, picture, {
      aspectRatio: "3/2"
    })), /*#__PURE__*/React.createElement(WithDisabledControl, {
      isDisabled: areControlsDisabled,
      onEnable: enableControls,
      placement: "top-start",
      t: context.t
    }, /*#__PURE__*/React.createElement(Checkbox, {
      disabled: areControlsDisabled,
      id: `${widgetId.current}-${value}`,
      checked: selectedValues.includes(value),
      onChange: () => {
        handleCheckboxClick(value, title);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: s.optionLabel
    }, /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      weight: "bold"
    }, title)))), text && /*#__PURE__*/React.createElement(Text, {
      size: "tiny"
    }, text)));
  });
  return /*#__PURE__*/React.createElement(WidgetLayout, {
    text: data.text,
    secondaryButton: data.secondaryButton,
    primaryButton: data.primaryButton,
    context: context,
    selectedValues: selectedValues,
    selectedTitles: selectedTitles,
    onSecondaryButtonClick: handleButtonClick('secondary_button_click', (_data$secondaryButton = data.secondaryButton) == null ? void 0 : _data$secondaryButton.label),
    onPrimaryButtonClick: handleButtonClick('primary_button_click', (_data$primaryButton = data.primaryButton) == null ? void 0 : _data$primaryButton.label),
    footerButtonsAsColumn: data.footerButtonsAsColumn,
    gap: data.borderlessOptions ? 'big' : 'normal',
    disabled: areControlsDisabled,
    onEnableControls: enableControls
  }, cards);
};
export const MULTI_SELECT_WIDGET = 'MULTI_SELECT_WIDGET';
//# sourceMappingURL=MultiSelectWidget.js.map